import React from 'react';

/**
 * Allow the user to install a Custom Flow service and enter anything into the url field, and optionally provide basic authentication
 * @param {Object} newServiceData = {} - Object containing all the data about the new service being created
 * @param {Function} setNewServiceDetails = {} - Function on ServiceController that allows us to update the newServiceData
 */
const NewCustomService = ({ newServiceData, setNewServiceDetails }) => (
    <>
        <h1>New Custom Service</h1>
        <h4>Here you can install a custom service for Flow</h4>
        <label>
            Name:
            <span className="input-required"> *</span>
        </label>
        <input
            className="form-control"
            onChange={({ target }) => setNewServiceDetails(target.value, 'developerName')}
            value={newServiceData.developerName}
            required
        />
        <label>
            Url:
            <span className="input-required"> *</span>
        </label>
        <input
            className="form-control"
            onChange={({ target }) => setNewServiceDetails(target.value, 'url')}
            value={newServiceData.url}
            required
        />

        <h5>If your custom service requries basic authentication (username/password) then enter those credentials here</h5>
        <label>Username: </label>
        <input
            className="form-control"
            onChange={({ target }) => setNewServiceDetails(target.value, 'basicUsername')}
            value={newServiceData.basicUsername}
        />
        <label>Password: </label>
        <input
            className="form-control"
            onChange={({ target }) => setNewServiceDetails(target.value, 'basicPassword')}
            value={newServiceData.basicPassword}
            type="password"
        />
    </>
);

export default NewCustomService;
